module.exports={
    url_host: process.env.NODE_ENV === 'development' ? '/api' : 'https://dj.zhihuiqilu.cn/',
}



// WEBPACK FOOTER //
// ./src/utils/comfig.js